import * as React from 'react';
import AntCheckbox, { CheckboxProps as AntCheckboxProps } from 'antd/lib/checkbox';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';
export interface CheckboxProps extends AntCheckboxProps {}

export class Checkbox extends React.Component<CheckboxProps, {}> {
	render() {
		const props = this.props;
		const { className, ...restProps } = props;

		return <AntCheckbox className={classNames(styles.checkbox, className)} {...restProps} />;
	}
}

export default Checkbox;
